import { AttrTypeName } from "src/types/AttrType";

export const copyByValueTypes = new Set<string>([
  AttrTypeName.date,
  AttrTypeName.dateTime,
  AttrTypeName.time,
  AttrTypeName.number,
  AttrTypeName.int,
  AttrTypeName.image,
  AttrTypeName.dictSingle,
  AttrTypeName.externalLink,
  AttrTypeName.string,
  AttrTypeName.file,
  AttrTypeName.usersList,
  AttrTypeName.object,
]);

export const attrTypesForUniqueValue = new Set<string>([
  AttrTypeName.string,
  AttrTypeName.article,
  AttrTypeName.int,
  AttrTypeName.number,
]);
